import {FancyTextPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-fancy-text-options/poster-editing-fancy-text-options.types';
import {useEffect} from 'react';
import type {ColorFillOption} from '@Components/poster-editor/components/poster-editing-side-panel/poster-editing-side-panel.types';
import {COLOR_OBJECT_IDS} from '@Components/poster-editor/components/poster-editing-side-panel/poster-editing-side-panel.types';
import {useGetKeyFromFancyTextItem} from '@Hooks/poster-editor/useGetKeyFromFancyTextItem';
import {useGetKeyFromShadowOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveItem';
import {ShadowOrGlowType} from '@postermywall/fabricjs-2';

export function useisOpenedFancyTextPanelValid(
  currentlyOpenedPanel: FancyTextPanels,
  setcurrentlyOpenedPanel: (newVal: FancyTextPanels) => void,
  selectedColorId: ColorFillOption
): void {
  const colors = useGetKeyFromFancyTextItem('colors');
  const shadowOrGlowType = useGetKeyFromShadowOfActiveItem('shadowOrGlowType');

  useEffect((): void => {
    if (colors && currentlyOpenedPanel === FancyTextPanels.COLOR && colors.length < COLOR_OBJECT_IDS.indexOf(selectedColorId) + 1) {
      setcurrentlyOpenedPanel(FancyTextPanels.DEFAULT);
    }
  }, [colors]);

  useEffect((): void => {
    if (shadowOrGlowType !== ShadowOrGlowType.CUSTOM_SHADOW && currentlyOpenedPanel === FancyTextPanels.SHADOW) {
      setcurrentlyOpenedPanel(FancyTextPanels.DEFAULT);
    }
  }, [shadowOrGlowType]);

  return;
}
